import type { OfficeToastApi, ToastOptions } from 'components/misc/Toaster'
import type { FileRejection } from 'react-dropzone'

/**
 * Module-level bridge that lets non-React code (redux thunks, connected
 * `mapDispatchToProps`) fire toasts on the redux-independent context toaster.
 *
 * `ToastBridgeConnector` (rendered inside `ToastProvider`) registers the live
 * office toast API here on mount and clears it on unmount. Callers import
 * `toastBridge` and call it like the old `dispatch({ type: 'ADD_TOAST' })`.
 */
let api: OfficeToastApi | null = null

export const setToastBridge = (next: OfficeToastApi | null) => {
    api = next
}

const warnUnready = () =>
    console.warn('toastBridge called before ToastBridgeConnector mounted; toast dropped')

export const toastBridge: OfficeToastApi = {
    addToast: (options?: ToastOptions) => (api ? api.addToast(options) : warnUnready()),
    deleteToast: (id: string) => api?.deleteToast(id),
    deleteAllToasts: () => api?.deleteAllToasts(),
    onFilesRejected: (files: FileRejection[]) => (api ? api.onFilesRejected(files) : warnUnready()),
}
